import { render, staticRenderFns } from "./LatestDevelopments.vue?vue&type=template&id=dbfeaf7e&scoped=true&"
import script from "./LatestDevelopments.vue?vue&type=script&lang=js&"
export * from "./LatestDevelopments.vue?vue&type=script&lang=js&"
import style0 from "./LatestDevelopments.vue?vue&type=style&index=0&id=dbfeaf7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbfeaf7e",
  null
  
)

export default component.exports